export default "__VITE_ASSET__5VnNuNqC__"